import { ButtonVariant, ButtonVariantConfig } from '~/models/app/button'

export const buttonVariantConfigs: Partial<Record<
  ButtonVariant,
  ButtonVariantConfig
>> = {
  orange: {
    solid: {
      base: [
        'tw-text-white',
        'tw-bg-orange-400',
        'tw-border',
        'tw-border-solid',
        'tw-border-orange-400'
      ],
      hover: [
        'hover:tw-bg-orange-500',
        'hover:tw-border-orange-500',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-orange-600', 'active:tw-border-orange-600'],
      pressed: ['!tw-bg-orange-600', '!tw-border-orange-600', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-orange-200']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-orange-400',
        'tw-border-orange-400'
      ],
      hover: [
        'hover:tw-bg-orange-400',
        'hover:tw-text-white',
        'hover:tw-border-orange-400'
      ],
      active: ['active:tw-bg-orange-500', 'active:tw-border-orange-500'],
      pressed: [
        '!tw-bg-orange-500',
        '!tw-border-orange-500',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-orange-200']
    },
    tertiary: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-orange-400',
        'tw-border-transparent'
      ],
      hover: [
        'hover:tw-bg-orange-50',
        'hover:tw-text-orange-400',
        'hover:tw-border-orange-50'
      ],
      active: ['active:tw-bg-orange-100', 'active:tw-border-orange-100'],
      pressed: [
        '!tw-bg-orange-100',
        '!tw-border-orange-100',
        '!tw-text-orange-400 active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-orange-200']
    }
  },
  whatsapp: {
    solid: {
      base: ['tw-bg-whatsapp', 'tw-text-white'],
      hover: [
        'hover:tw-bg-whatsapp-dark',
        'hover:tw-border-whatsapp-dark',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-whatsapp-dark', 'active:tw-border-whatsapp-dark'],
      pressed: ['!tw-bg-whatsapp-dark', '!tw-border-whatsapp-dark', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-whatsapp']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-whatsapp',
        'tw-border-whatsapp'
      ],
      hover: [
        'hover:tw-bg-whatsapp',
        'hover:tw-text-white',
        'hover:tw-border-whatsapp'
      ],
      active: ['active:tw-bg-whatsapp-dark', 'active:tw-border-whatsapp-dark'],
      pressed: [
        '!tw-bg-whatsapp-dark',
        '!tw-border-whatsapp-dark',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-whatsapp']
    }
  },
  secondary: {
    solid: {
      base: [
        'tw-text-white',
        'tw-bg-blue',
        'tw-border',
        'tw-border-solid',
        'tw-border-blue'
      ],
      hover: [
        'hover:tw-bg-blue-600',
        'hover:tw-border-blue-600',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-blue-600', 'active:tw-border-blue-600'],
      pressed: ['!tw-bg-blue-600', '!tw-border-blue-600', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-blue-200']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-blue',
        'tw-border-blue'
      ],
      hover: [
        'hover:tw-bg-blue',
        'hover:tw-text-white',
        'hover:tw-border-blue'
      ],
      active: ['active:tw-bg-blue-600', 'active:tw-border-blue-600'],
      pressed: [
        '!tw-bg-blue-600',
        '!tw-border-blue-600',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-blue-200']
    },
    tertiary: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-blue',
        'tw-border-transparent'
      ],
      hover: [
        'hover:tw-bg-blue-50',
        'hover:tw-text-blue',
        'hover:tw-border-blue-50'
      ],
      active: ['active:tw-bg-blue-100', 'active:tw-border-blue-100'],
      pressed: [
        '!tw-bg-blue-100',
        '!tw-border-blue-100',
        '!tw-text-blue active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-blue-200']
    }
  },

  success: {
    solid: {
      base: [
        'tw-text-white',
        'tw-bg-green',
        'tw-border',
        'tw-border-solid',
        'tw-border-green'
      ],
      hover: [
        'hover:tw-bg-green-600',
        'hover:tw-border-green-600',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-green-700', 'active:tw-border-green-700'],
      pressed: ['!tw-bg-green-700', '!tw-border-green-700', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-green-200']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-green',
        'tw-border-green'
      ],
      hover: [
        'hover:tw-bg-green',
        'hover:tw-text-white',
        'hover:tw-border-green'
      ],
      active: ['active:tw-bg-green-600', 'active:tw-border-green-600'],
      pressed: [
        '!tw-bg-green-600',
        '!tw-border-green-600',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-green-200']
    },
    tertiary: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-green',
        'tw-border-transparent'
      ],
      hover: [
        'hover:tw-bg-green-50',
        'hover:tw-text-green',
        'hover:tw-border-green-50'
      ],
      active: ['active:tw-bg-green-100', 'active:tw-border-green-100'],
      pressed: [
        '!tw-bg-green-100',
        '!tw-border-green-100',
        '!tw-text-green active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-green-200']
    }
  },
  danger: {
    solid: {
      base: [
        'tw-text-white',
        'tw-bg-red-400',
        'tw-border',
        'tw-border-solid',
        'tw-border-red-400'
      ],
      hover: [
        'hover:tw-bg-red-500',
        'hover:tw-border-red-500',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-red-600', 'active:tw-border-red-600'],
      pressed: ['!tw-bg-red-600', '!tw-border-red-600', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-red-200']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-red-400',
        'tw-border-red-400'
      ],
      hover: [
        'hover:tw-bg-red-400',
        'hover:tw-text-white',
        'hover:tw-border-red-400'
      ],
      active: ['active:tw-bg-red-500', 'active:tw-border-red-500'],
      pressed: [
        '!tw-bg-red-500',
        '!tw-border-red-500',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-red-200']
    },
    tertiary: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-red-400',
        'tw-border-transparent'
      ],
      hover: [
        'hover:tw-bg-red-50',
        'hover:tw-text-red-400',
        'hover:tw-border-red-50'
      ],
      active: ['active:tw-bg-red-100', 'active:tw-border-red-100'],
      pressed: [
        '!tw-bg-red-100',
        '!tw-border-red-100',
        '!tw-text-red-400 active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-red-200']
    }
  },
  warning: {
    solid: {
      base: [
        'tw-text-white',
        'tw-bg-amber-500',
        'tw-border',
        'tw-border-solid',
        'tw-border-amber-500'
      ],
      hover: [
        'hover:tw-bg-amber-600',
        'hover:tw-border-amber-600',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-amber-700', 'active:tw-border-amber-700'],
      pressed: ['!tw-bg-amber-700', '!tw-border-amber-700', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-amber-200']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-amber-500',
        'tw-border-amber-500'
      ],
      hover: [
        'hover:tw-bg-amber-500',
        'hover:tw-text-white',
        'hover:tw-border-amber-500'
      ],
      active: ['active:tw-bg-amber-600', 'active:tw-border-amber-600'],
      pressed: [
        '!tw-bg-amber-600',
        '!tw-border-amber-600',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-amber-200']
    },
    tertiary: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-amber-500',
        'tw-border-transparent'
      ],
      hover: [
        'hover:tw-bg-amber-50',
        'hover:tw-text-amber-500',
        'hover:tw-border-amber-50'
      ],
      active: ['active:tw-bg-amber-100', 'active:tw-border-amber-100'],
      pressed: [
        '!tw-bg-amber-100',
        '!tw-border-amber-100',
        '!tw-text-amber-500 active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-amber-200']
    }
  },
  neutral: {
    solid: {
      base: [
        'tw-text-white',
        'tw-bg-grey-600',
        'tw-border',
        'tw-border-solid',
        'tw-border-grey-600'
      ],
      hover: [
        'hover:tw-bg-grey-700',
        'hover:tw-border-grey-700',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-grey-800', 'active:tw-border-grey-800'],
      pressed: ['!tw-bg-grey-800', '!tw-border-grey-800', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-grey-300']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-grey-600',
        'tw-border-grey-600'
      ],
      hover: [
        'hover:tw-bg-grey-600',
        'hover:tw-text-white',
        'hover:tw-border-grey-600'
      ],
      active: ['active:tw-bg-grey-700', 'active:tw-border-grey-700'],
      pressed: [
        '!tw-bg-grey-700',
        '!tw-border-grey-700',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-grey-300']
    },
    tertiary: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-grey-600',
        'tw-border-transparent'
      ],
      hover: [
        'hover:tw-bg-grey-50',
        'hover:tw-text-grey-600',
        'hover:tw-border-grey-50'
      ],
      active: ['active:tw-bg-grey-100', 'active:tw-border-grey-100'],
      pressed: [
        '!tw-bg-grey-100',
        '!tw-border-grey-100',
        '!tw-text-grey-600 active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-grey-300']
    }
  },
  offer: {
    solid: {
      base: [
        'tw-text-white',
        'tw-bg-offer-green-500',
        'tw-border',
        'tw-border-solid',
        'tw-border-offer-green-500'
      ],
      hover: [
        'hover:tw-bg-offer-green-600',
        'hover:tw-border-offer-green-600',
        'hover:tw-text-white'
      ],
      active: [
        'active:tw-bg-offer-green-700',
        'active:tw-border-offer-green-700'
      ],
      pressed: [
        '!tw-bg-offer-green-700',
        '!tw-border-offer-green-700',
        'active'
      ],
      focus: [
        'focus-visible:tw-ring-2',
        'focus-visible:tw-ring-offer-green-200'
      ]
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-offer-green-500',
        'tw-border-offer-green-500'
      ],
      hover: [
        'hover:tw-bg-offer-green-500',
        'hover:tw-text-white',
        'hover:tw-border-offer-green-500'
      ],
      active: [
        'active:tw-bg-offer-green-600',
        'active:tw-border-offer-green-600'
      ],
      pressed: [
        '!tw-bg-offer-green-600',
        '!tw-border-offer-green-600',
        '!tw-text-white active'
      ],
      focus: [
        'focus-visible:tw-ring-2',
        'focus-visible:tw-ring-offer-green-200'
      ]
    },
    tertiary: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-offer-green-500',
        'tw-border-transparent'
      ],
      hover: [
        'hover:tw-bg-offer-green-50',
        'hover:tw-text-offer-green-500',
        'hover:tw-border-offer-green-50'
      ],
      active: [
        'active:tw-bg-offer-green-100',
        'active:tw-border-offer-green-100'
      ],
      pressed: [
        '!tw-bg-offer-green-100',
        '!tw-border-offer-green-100',
        '!tw-text-offer-green-500 active'
      ],
      focus: [
        'focus-visible:tw-ring-2',
        'focus-visible:tw-ring-offer-green-200'
      ]
    }
  },
  leasing: {
    solid: {
      base: [
        'tw-text-white',
        'tw-bg-teal-500',
        'tw-border',
        'tw-border-solid',
        'tw-border-teal-500'
      ],
      hover: [
        'hover:tw-bg-teal-600',
        'hover:tw-border-teal-600',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-teal-700', 'active:tw-border-teal-700'],
      pressed: ['!tw-bg-teal-700', '!tw-border-teal-700', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-teal-200']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-teal-500',
        'tw-border-teal-500'
      ],
      hover: [
        'hover:tw-bg-teal-500',
        'hover:tw-text-white',
        'hover:tw-border-teal-500'
      ],
      active: ['active:tw-bg-teal-600', 'active:tw-border-teal-600'],
      pressed: [
        '!tw-bg-teal-600',
        '!tw-border-teal-600',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-teal-200']
    },
    tertiary: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-teal-500',
        'tw-border-transparent'
      ],
      hover: [
        'hover:tw-bg-teal-50',
        'hover:tw-text-teal-500',
        'hover:tw-border-teal-50'
      ],
      active: ['active:tw-bg-teal-100', 'active:tw-border-teal-100'],
      pressed: [
        '!tw-bg-teal-100',
        '!tw-border-teal-100',
        '!tw-text-teal-500 active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-teal-200']
    }
  },
  light: {
    solid: {
      base: [
        'tw-text-grey-900',
        'tw-bg-grey-300',
        'tw-border',
        'tw-border-solid',
        'tw-border-grey-300'
      ],
      hover: ['hover:tw-bg-grey-300', 'hover:tw-border-grey-300'],
      active: ['active:tw-bg-grey-400', 'active:tw-border-grey-400'],
      pressed: ['!tw-bg-grey-400', '!tw-border-grey-400', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-grey-300']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-grey-900',
        'tw-border-grey-400'
      ],
      hover: [
        'hover:tw-bg-grey-400',
        'hover:tw-text-grey-900',
        'hover:tw-border-grey-400'
      ],
      active: ['active:tw-bg-grey-400', 'active:tw-border-grey-400'],
      pressed: [
        '!tw-bg-grey-400',
        '!tw-border-grey-400',
        '!tw-text-grey-900 active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-grey-300']
    }
  },
  viber: {
    solid: {
      base: ['tw-bg-viber', 'tw-text-white'],
      hover: [
        'hover:tw-bg-viber-dark',
        'hover:tw-border-viber-dark',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-viber-dark', 'active:tw-border-viber'],
      pressed: ['!tw-bg-viber-dark', '!tw-border-viber-dark', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-viber']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-viber',
        'tw-border-viber'
      ],
      hover: [
        'hover:tw-bg-viber-dark',
        'hover:tw-text-white',
        'hover:tw-border-viber-dark'
      ],
      active: ['active:tw-bg-viber-dark', 'active:tw-border-viber-dark'],
      pressed: [
        '!tw-bg-viber-dark',
        '!tw-border-viber-dark',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-viber']
    }
  },
  primary: {
    solid: {
      base: [
        'tw-text-white',
        'tw-bg-primary',
        'tw-border',
        'tw-border-solid',
        'tw-border-primary'
      ],
      hover: [
        'hover:tw-bg-primary-600',
        'hover:tw-border-primary-600',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-primary-700', 'active:tw-border-primary-700'],
      pressed: ['!tw-bg-primary-700', '!tw-border-primary-700', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-primary-300']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-primary',
        'tw-border-primary'
      ],
      hover: [
        'hover:tw-bg-primary',
        'hover:tw-text-white',
        'hover:tw-border-primary'
      ],
      active: ['active:tw-bg-primary-600', 'active:tw-border-primary-600'],
      pressed: [
        '!tw-bg-primary-600',
        '!tw-border-primary-600',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-primary-300']
    },
    tertiary: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-primary',
        'tw-border-transparent'
      ],
      hover: [
        'hover:tw-bg-primary-50',
        'hover:tw-text-primary',
        'hover:tw-border-primary-50'
      ],
      active: ['active:tw-bg-primary-100', 'active:tw-border-primary-100'],
      pressed: [
        '!tw-bg-primary-100',
        '!tw-border-primary-100',
        '!tw-text-primary active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-primary-300']
    }
  },
  turbo: {
    solid: {
      base: ['tw-bg-promote-turbo', 'tw-text-white'],
      hover: [
        'hover:tw-bg-promote-turbo-dark',
        'hover:tw-border-promote-turbo-dark',
        'hover:tw-text-white'
      ],
      active: [
        'active:tw-bg-promote-turbo-dark',
        'active:tw-border-promote-turbo-dark'
      ],
      pressed: [
        '!tw-bg-promote-turbo-dark',
        '!tw-border-promote-turbo-dark',
        'active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-promote-turbo']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-promote-turbo',
        'tw-border-promote-turbo'
      ],
      hover: [
        'hover:tw-bg-promote-turbo',
        'hover:tw-text-white',
        'hover:tw-border-promote-turbo'
      ],
      active: [
        'active:tw-bg-promote-turbo-dark',
        'active:tw-border-promote-turbo-dark'
      ],
      pressed: [
        '!tw-bg-promote-turbo-dark',
        '!tw-border-promote-turbo-dark',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-promote-turbo']
    }
  },
  super: {
    solid: {
      base: ['tw-bg-green-500', 'tw-text-white'],
      hover: [
        'hover:tw-bg-green-600',
        'hover:tw-border-green-600',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-green-600', 'active:tw-border-green-600'],
      pressed: ['!tw-bg-green-600', '!tw-border-green-600', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-green-200']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-green-500',
        'tw-border-green-500'
      ],
      hover: [
        'hover:tw-bg-green-500',
        'hover:tw-text-white',
        'hover:tw-border-green-500'
      ],
      active: ['active:tw-bg-green-600', 'active:tw-border-green-600'],
      pressed: [
        '!tw-bg-green-600',
        '!tw-border-green-600',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-green-200']
    }
  },
  top: {
    solid: {
      base: ['tw-bg-blue-600', 'tw-text-white'],
      hover: [
        'hover:tw-bg-blue-700',
        'hover:tw-border-blue-700',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-blue-700', 'active:tw-border-blue-700'],
      pressed: ['!tw-bg-blue-700', '!tw-border-blue-700', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-blue-200']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-blue-600',
        'tw-border-blue-600'
      ],
      hover: [
        'hover:tw-bg-blue-600',
        'hover:tw-text-white',
        'hover:tw-border-blue-600'
      ],
      active: ['active:tw-bg-blue-700', 'active:tw-border-blue-700'],
      pressed: [
        '!tw-bg-blue-700',
        '!tw-border-blue-700',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-blue-200']
    }
  },
  facebook: {
    solid: {
      base: ['tw-bg-facebook', 'tw-text-white'],
      hover: [
        'hover:tw-bg-facebook-dark',
        'hover:tw-border-facebook-dark',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-facebook-dark', 'active:tw-border-facebook-dark'],
      pressed: ['!tw-bg-facebook-dark', '!tw-border-facebook-dark', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-facebook']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-facebook',
        'tw-border-facebook'
      ],
      hover: [
        'hover:tw-bg-facebook',
        'hover:tw-text-white',
        'hover:tw-border-facebook'
      ],
      active: ['active:tw-bg-facebook-dark', 'active:tw-border-facebook-dark'],
      pressed: [
        '!tw-bg-facebook-dark',
        '!tw-border-facebook-dark',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-facebook']
    }
  },
  x: {
    solid: {
      base: ['tw-bg-x', 'tw-text-white'],
      hover: [
        'hover:tw-bg-grey-900',
        'hover:tw-border-grey-900',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-grey-900', 'active:tw-border-grey-900'],
      pressed: ['!tw-bg-grey-900', '!tw-border-grey-900', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-x']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-x',
        'tw-border-x'
      ],
      hover: ['hover:tw-bg-x', 'hover:tw-text-white', 'hover:tw-border-x'],
      active: ['active:tw-bg-grey-900', 'active:tw-border-grey-900'],
      pressed: [
        '!tw-bg-grey-900',
        '!tw-border-grey-900',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-x']
    }
  },
  tbi: {
    solid: {
      base: ['tw-bg-tbi', 'tw-text-white'],
      hover: [
        'hover:tw-bg-tbi-dark',
        'hover:tw-border-tbi-dark',
        'hover:tw-text-white'
      ],
      active: ['active:tw-bg-tbi-dark', 'active:tw-border-tbi-dark'],
      pressed: ['!tw-bg-tbi-dark', '!tw-border-tbi-dark', 'active'],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-tbi']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-tbi',
        'tw-border-tbi'
      ],
      hover: ['hover:tw-bg-tbi', 'hover:tw-text-white', 'hover:tw-border-tbi'],
      active: ['active:tw-bg-tbi-dark', 'active:tw-border-tbi-dark'],
      pressed: [
        '!tw-bg-tbi-dark',
        '!tw-border-tbi-dark',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-tbi']
    }
  },
  piraeus: {
    solid: {
      base: [
        'tw-bg-piraeus',
        'tw-text-white',
        'tw-border',
        'tw-border-solid',
        'tw-border-piraeus'
      ],
      hover: [
        'hover:tw-bg-piraeus-secondary',
        'hover:tw-border-piraeus-secondary',
        'hover:tw-text-white'
      ],
      active: [
        'active:tw-bg-piraeus-secondary',
        'active:tw-border-piraeus-secondary'
      ],
      pressed: [
        '!tw-bg-piraeus-secondary',
        '!tw-border-piraeus-secondary',
        'active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-piraeus']
    },
    outline: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-piraeus',
        'tw-border-piraeus'
      ],
      hover: [
        'hover:tw-bg-piraeus',
        'hover:tw-text-white',
        'hover:tw-border-piraeus'
      ],
      active: [
        'active:tw-bg-piraeus-secondary',
        'active:tw-border-piraeus-secondary'
      ],
      pressed: [
        '!tw-bg-piraeus-secondary',
        '!tw-border-piraeus-secondary',
        '!tw-text-white active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-piraeus']
    },
    tertiary: {
      base: [
        'tw-bg-transparent',
        'tw-border',
        'tw-border-solid',
        'tw-text-piraeus',
        'tw-border-transparent'
      ],
      hover: [
        'hover:tw-bg-piraeus-third',
        'hover:tw-text-piraeus',
        'hover:tw-border-piraeus-third'
      ],
      active: ['active:tw-bg-piraeus-third', 'active:tw-border-piraeus-third'],
      pressed: [
        '!tw-bg-piraeus-third',
        '!tw-border-piraeus-third',
        '!tw-text-piraeus active'
      ],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-piraeus']
    }
  },
  link: {
    solid: {
      base: ['tw-bg-transparent', 'tw-text-primary'],
      hover: [
        'hover:tw-text-primary-600',
        'hover:tw-underline',
        'hover:tw-text-primary-600'
      ],
      active: ['active:tw-text-primary-900', 'active:tw-underline'],
      pressed: [],
      focus: ['focus-visible:tw-ring-2', 'focus-visible:tw-ring-primary-200']
    }
  }
}
